import { useState, useEffect } from 'react';

export function useScreenSize(screenSize) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= screenSize);

    const handleResize = () => {
        setIsMobile(window.innerWidth <= screenSize);
      };
    
      useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

    return isMobile
}

